import {
  getCashBidLocations,
  getCashBidLocationNearByHistory,
  createPurchaseContract,
  createOffer,
  getOffers,
  cancelOffer,
  getHedgingActiveStatus,
  getHTAFees,
} from '../../../apis/premier-plus-api';
import moment from 'moment';
import {
  toggleSidebarVisibility,
  handleApiError,
} from '../../../shared/actions';

export const initCashBids = (locationId, contractType, commodity) => (async (dispatch, getState) => {
  dispatch({
    type: 'INIT_CASH_BIDS',
  });
  const isBuyGrainWidgetUser = getState().auth.isBuyGrainWidgetUser;
  const isPurchaseContractModalUser = getState().auth.isPurchaseContractModalUser;
  if (isBuyGrainWidgetUser === true) {
    if (locationId !== undefined && locationId !== null && locationId !== '') {
      dispatch(toggleSidebarVisibility());
      dispatch({
        type: 'SET_CASH_BIDS_DEFAULT_LOCATION_ID',
        locationId: locationId,
      });
    }
  }
  else if (isPurchaseContractModalUser === true) {
    if (locationId !== undefined && locationId !== null && locationId !== '') {
      dispatch(toggleSidebarVisibility());
      dispatch({
        type: 'SET_CASH_BIDS_DEFAULT_LOCATION_ID',
        locationId: locationId,
      });
    }
    dispatch({
      type: 'SET_PURCHASE_CONTRACT_MODAL_DEFAULTS',
      commodity: commodity ?? null,
      contractType: contractType ?? null,
    });
  }
});

export const fetchCashBidLocations = () => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_REQUESTED_FETCH_CASH_BID_LOCATIONS',
  });
  const {
    selectedCommodity,
    selectedMonth,
    showAllLocations,
  } = getState().cashBids;
  var response = null;
  try {
    response = await getCashBidLocations(selectedCommodity, selectedMonth, showAllLocations);
  }
  catch (error) {
    dispatch({
      type: 'FETCH_CASH_BID_LOCATIONS_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_CASH_BID_LOCATIONS',
    locations: response.body,
  });
  if (getState().cashBids.defaultLocationId !== null) {
    const defaultLocation = response.body.find((location) => location.locationName === getState().cashBids.defaultLocationId);
    if (defaultLocation !== undefined) {
      dispatch(userSelectedCashBidLocation(defaultLocation));
      const isBuyGrainWidgetUser = getState().auth.isBuyGrainWidgetUser;
      const isPurchaseContractModalUser = getState().auth.isPurchaseContractModalUser;
      if (isBuyGrainWidgetUser === true) {
        dispatch(showCashBidModal());
      }
      else if (isPurchaseContractModalUser === true) {
        const { defaultPurchaseContractCommodity, defaultPurchaseContractContractType } = getState().cashBids;
        const bidGroup = defaultPurchaseContractCommodity !== null
          ? defaultLocation.bids.find(b => b.commodity.toUpperCase() === defaultPurchaseContractCommodity.toUpperCase())
          : defaultLocation.bids[0];
        if (bidGroup !== undefined && bidGroup.bids.length > 0) {
          const cashBid = bidGroup.bids[0];
          await dispatch(showPurchaseContractModal(cashBid, defaultLocation, cashBid.futures, false));
          if (defaultPurchaseContractContractType !== null && defaultPurchaseContractContractType !== 'Priced') {
            dispatch(setPurchaseContractType(defaultPurchaseContractContractType));
          }
        }
        else {
          dispatch({
            type: 'SHOW_PURCHASE_CONTRACT_NO_BIDS_MODAL',
          });
        }
      }
    }
  }
});

export const userSelectedCashBidLocation = (location) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_CASH_BID_LOCATION',
    location: location,
  });
});

export const userSelectedCashBidCommodity = (commodity) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_CASH_BID_COMMODITY',
    commodity: commodity,
  });
  dispatch(fetchCashBidLocations());
});

export const userSelectedCashBidMonth = (month) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_CASH_BID_MONTH',
    month: month,
  });
  dispatch(fetchCashBidLocations());
});

export const toggleShowAllLocations = () => (async (dispatch, getState) => {
  dispatch({
    type: 'TOGGLE_SHOW_ALL_CASH_BID_LOCATIONS',
  });
  dispatch(fetchCashBidLocations());
});

export const resetCashBidFilters = () => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_RESET_CASH_BID_FILTERS',
  });
  dispatch(fetchCashBidLocations());
});

export const showCashBidModal = () => ((dispatch, getState) => {
  dispatch({
    type: 'SHOW_CASH_BID_MODAL',
  });
  dispatch(fetchCashBidLocationNearByHistory());
});

export const hideCashBidModal = () => ((dispatch, getState) => {
  dispatch({
    type: 'HIDE_CASH_BID_MODAL',
  });
});

export const userSelectedCashBidLocationNearByHistoricalCommodity = (historicalNearByCommodity) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_CASHBID_LOCATION_NEAR_BY_HISTORICAL_COMMODITY',
    historicalNearByCommodity: historicalNearByCommodity,
  });
});

export const userSelectedCashBidLocationNearByHistoricalStartDate = (historicalNearByStartDate) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_CASHBID_LOCATION_NEAR_BY_HISTORICAL_START_DATE',
    historicalNearByStartDate: historicalNearByStartDate,
  });
});

export const userSelectedCashBidLocationNearByHistoricalEndDate = (historicalNearByEndDate) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_CASHBID_LOCATION_NEAR_BY_HISTORICAL_END_DATE',
    historicalNearByEndDate: historicalNearByEndDate,
  });
});

export const fetchCashBidLocationNearByHistory = () => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_REQUESTED_FETCH_CASH_BID_LOCATION_NEAR_BY_HISTORY',
  });
  const {
    historicalNearByCommodity,
    historicalNearByStartDate,
    historicalNearByEndDate,
  } = getState().cashBids;
  var response = null;
  try {
    response = await getCashBidLocationNearByHistory(historicalNearByCommodity.basisRollingSymbol, historicalNearByCommodity.cashPriceRollingSymbol, historicalNearByStartDate, historicalNearByEndDate);
  }
  catch (error) {
    dispatch({
      type: 'FETCH_CASH_BID_LOCATION_NEAR_BY_HISTORY_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_CASH_BID_LOCATION_NEAR_BY_HISTORY',
    history: response.body,
  });
});

export const showPurchaseContractModal = (cashBid, location, futures, isMakeOfferInterface) => (async (dispatch, getState) => {
  if (isMakeOfferInterface === true) {
    dispatch(fetchOffers());
    dispatch({
      type: 'SHOW_PURCHASE_CONTRACT_MODAL',
      cashBid: cashBid,
      location: location,
      futures: futures,
      isMakeOfferInterface: isMakeOfferInterface,
    });
  }
  else {
    const response = await getHedgingActiveStatus();
    var hedgingActive = response.body;
    const currentHourInCentralTime = parseInt(new Date().toLocaleString('en-US', {
      hour: 'numeric',
      hour12: false,
      timeZone: 'America/Chicago',
    }));
    if (hedgingActive === true || currentHourInCentralTime >= 7 && currentHourInCentralTime < 16) {
      await dispatch(fetchHTAFees());
      dispatch({
        type: 'SHOW_PURCHASE_CONTRACT_MODAL',
        cashBid: cashBid,
        location: location,
        futures: futures,
        isMakeOfferInterface: isMakeOfferInterface,
      });
    }
    else {
      dispatch({
        type: 'SHOW_PURCHASE_CONTRACT_INVALID_TIME_SPAN_MODAL',
      });
    }
  }
});

export const fetchHTAFees = () => (async (dispatch, getState) => {
  var response = null;
  try {
    response = await getHTAFees();
  }
  catch (error) {
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_HTA_FEES',
    htaFees: response.body,
  });
});

export const hidePurchaseContractInvalidTimeSpanModal = () => ((dispatch, getState) => {
  dispatch({
    type: 'HIDE_PURCHASE_CONTRACT_INVALID_TIME_SPAN_MODAL',
  });
});

export const hidePurchaseContractModal = () => ((dispatch, getState) => {
  dispatch({
    type: 'HIDE_PURCHASE_CONTRACT_MODAL',
  });
});

export const userCancelledPurchaseContract = () => ((dispatch, getState) => {
  dispatch({
    type: 'USER_CANCELLED_PURCHASE_CONTRACT',
  });
});

export const setPurchaseContractModalActiveTabIndex = (index) => ((dispatch, getState) => {
  dispatch({
    type: 'SET_PURCHASE_CONTRACT_MODAL_ACTIVE_INDEX',
    index: index,
  });
});

const monthsToFuturesSymbolInclusive = (symbol) => {
  // Parse the symbol (e.g., ZSK25)
  const monthCode = symbol[2]; // Get the month code (K)
  const yearStr = symbol.slice(3); // Get the year (25)
  
  // Map of futures month codes to month numbers (0-based for JavaScript Date)
  const monthCodes = {
      'F': 0, // January
      'G': 1, // February
      'H': 2, // March
      'J': 3, // April
      'K': 4, // May
      'M': 5, // June
      'N': 6, // July
      'Q': 7, // August
      'U': 8, // September
      'V': 9, // October
      'X': 10, // November
      'Z': 11 // December
  };
  
  // Construct the target date (1st day of the month)
  const targetYear = 2000 + parseInt(yearStr); // Convert '25' to 2025
  const targetMonth = monthCodes[monthCode]; // Get 0-based month
  const targetDate = new Date(targetYear, targetMonth, 1); // 1st day of the month
  
  // Get current date
  const currentDate = new Date();
  
  // Check if the target month and year match the current month and year
  if (targetDate.getFullYear() === currentDate.getFullYear() &&
      targetDate.getMonth() === currentDate.getMonth()) {
      return 0;
  }
  
  // Calculate the inclusive month count
  let monthsDiff = (targetDate.getFullYear() - currentDate.getFullYear()) * 12 +
                   (targetDate.getMonth() - currentDate.getMonth());
  
  // Add 1 to include the current month
  monthsDiff += 1;
  
  // Ensure the result is non-negative
  if (monthsDiff < 1) {
      monthsDiff = 1; // Count at least one month if target is in the past
  }
  
  return monthsDiff;
}

export const setPurchaseContractType = (contractType) => ((dispatch, getState) => {
  dispatch({
    type: 'SET_PURCHASE_CONTRACT_TYPE',
    contractType: contractType,
  });
  if (contractType === 'HTA') {
    var monthCount = monthsToFuturesSymbolInclusive(getState().cashBids.purchaseContractFutures.symbol);
    var commodity = getState().cashBids.purchaseContractCashBid.commodity;
    if (commodity === 'SOYBEANS' || commodity === 'Soybeans') {
      commodity = 'Beans';
    }
    else if (commodity === 'CORN' || commodity === 'Corn') {
      commodity = 'Corn';
    }
    const htaFees = getState().cashBids.htaFees;
    const htaFee = htaFees.find((fee) => fee.commodityId === commodity);
    dispatch({
      type: 'SET_PURCHASE_CONTRACT_HTA_FEE_AND_PRICE',
      htaFee: htaFee,
      monthCount: monthCount,
      futuresPrice: getState().cashBids.purchaseContractFutures.nonFormattedLastPrice,
    });
  }
});

export const setPurchaseContractNumberOfBushels = (numberOfBushels) => (async (dispatch, getState) => {
  const isMakeOfferInterface = getState().cashBids.isMakeOfferInterface;
  if (isMakeOfferInterface === true) {
    dispatch({
      type: 'SET_PURCHASE_CONTRACT_NUMBER_OF_BUSHELS',
      numberOfBushels: numberOfBushels,
    });
  }
  else {
    const currentHourInCentralTime = parseInt(new Date().toLocaleString('en-US', {
      hour: 'numeric',
      hour12: false,
      timeZone: 'America/Chicago',
    }));
    // if time is between 7AM CST and 4PM CST, then allow any amount of bushels.
    if (currentHourInCentralTime >= 7 && currentHourInCentralTime < 16) {
      dispatch({
        type: 'SET_PURCHASE_CONTRACT_NUMBER_OF_BUSHELS',
        numberOfBushels: numberOfBushels,
      });
    }
    else if (numberOfBushels > 25000) {
      dispatch({
        type: 'SHOW_PURCHASE_CONTRACT_INVALID_BUSHELS_MODAL',
      });
      dispatch({
        type: 'SET_PURCHASE_CONTRACT_NUMBER_OF_BUSHELS',
        numberOfBushels: 0,
      });
    }
    else {
      dispatch({
        type: 'SET_PURCHASE_CONTRACT_NUMBER_OF_BUSHELS',
        numberOfBushels: numberOfBushels,
      });
    }
  }
});

export const hidePurchaseContractInvalidBushelsModal = () => ((dispatch, getState) => {
  dispatch({
    type: 'HIDE_PURCHASE_CONTRACT_INVALID_BUSHELS_MODAL',
  });
});

export const hidePurchaseContractNoBidsModal = () => ((dispatch) => {
  dispatch({
    type: 'HIDE_PURCHASE_CONTRACT_NO_BIDS_MODAL',
  });
});

export const setPurchaseContractSettleGrain = (settleGrain) => ((dispatch, getState) => {
  dispatch({
    type: 'SET_PURCHASE_CONTRACT_SETTLE_GRAIN',
    settleGrain: settleGrain,
  });
});

export const setPurchaseContractSettleGrainPaymentType = (paymentType) => ((dispatch, getState) => {
  dispatch({
    type: 'SET_PURCHASE_CONTRACT_SETTLE_GRAIN_PAYMENT_TYPE',
    paymentType: paymentType,
  });
});

export const setPurchaseContractApplyToExistingContract = (apply) => ((dispatch, getState) => {
  dispatch({
    type: 'SET_PURCHASE_CONTRACT_APPLY_TO_EXISTING_CONTRACT',
    apply: apply,
  });
});

export const setPurchaseContractExistingContractNumber = (contractNumber) => ((dispatch, getState) => {
  dispatch({
    type: 'SET_PURCHASE_CONTRACT_EXISTING_CONTRACT_NUMBER',
    contractNumber: contractNumber,
  });
});

export const setPurchaseContractComments = (comments) => ((dispatch, getState) => {
  dispatch({
    type: 'SET_PURCHASE_CONTRACT_COMMENTS',
    comments: comments,
  });
});

export const setPurchaseContractAgreeToTerms = (agreeToTerms) => ((dispatch, getState) => {
  dispatch({
    type: 'SET_PURCHASE_CONTRACT_AGREE_TO_TERMS',
    agreeToTerms: agreeToTerms,
  });
});

export const setPurchaseContractSignature = (signature) => ((dispatch, getState) => {
  dispatch({
    type: 'SET_PURCHASE_CONTRACT_SIGNATURE',
    signature: signature,
  });
});

export const savePurchaseContract = () => (async (dispatch, getState) => {
  dispatch({
    type: 'SAVE_PURCHASE_CONTRACT_STARTED',
  });
  const {
    purchaseContractType,
    purchaseContractCashBid,
    purchaseContractLocation,
    purchaseContractFutures,
    purchaseContractNumberOfBushels,
    purchaseContractSettleGrain,
    purchaseContractSettleGrainPaymentType,
    purchaseContractComments,
    purchaseContractHTAFee,
    purchaseContractPrice,
    purchaseContractApplyToExistingContract,
    purchaseContractExistingContractNumber,
  } = getState().cashBids;
  const agvanceUser = getState().auth.authorization.agvanceUser;
  const emailAddress = getState().auth.authorization.emailAddress;
  const ipifyResponse = await fetch('https://api64.ipify.org?format=json');
  const ipifyResponseJson = await ipifyResponse.json();
  var response = null;
  try {
    response = await createPurchaseContract(agvanceUser, emailAddress, purchaseContractType, purchaseContractCashBid, purchaseContractLocation, purchaseContractFutures, purchaseContractNumberOfBushels, purchaseContractSettleGrain, purchaseContractSettleGrainPaymentType, purchaseContractComments, purchaseContractHTAFee, purchaseContractPrice, purchaseContractApplyToExistingContract, purchaseContractExistingContractNumber,ipifyResponseJson.ip);
  }
  catch (error) {
    dispatch({
      type: 'SAVE_PURCHASE_CONTRACT_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'SAVED_PURCHASE_CONTRACT',
    result: response.body,
  });
});

export const hidePurchaseContractSuccessModal = () => ((dispatch, getState) => {
  dispatch({
    type: 'HIDE_PURCHASE_CONTRACT_SUCCESS_MODAL',
  });
});

export const setOfferCashPrice = (cashPrice) => ((dispatch, getState) => {
  dispatch({
    type: 'SET_OFFER_CASH_PRICE',
    cashPrice: cashPrice,
  });
});

export const setOfferExpirationDate = (expirationDate) => ((dispatch, getState) => {
  console.log(expirationDate);
  dispatch({
    type: 'SET_OFFER_EXPIRATION_DATE',
    expirationDate: expirationDate,
  });
});

export const saveOffer = () => (async (dispatch, getState) => {
  dispatch({
    type: 'SAVE_OFFER_STARTED',
  });
  const {
    purchaseContractCashBid,
    offerCashPrice,
    offerExpirationDate,
    purchaseContractNumberOfBushels,
    purchaseContractComments,
    purchaseContractLocation,
  } = getState().cashBids;
  const agvanceUser = getState().auth.authorization.agvanceUser;
  const emailAddress = getState().auth.authorization.emailAddress;
  const ipifyResponse = await fetch('https://api64.ipify.org?format=json');
  const ipifyResponseJson = await ipifyResponse.json();
  var response = null;
  try {
    response = await createOffer(agvanceUser, emailAddress, purchaseContractCashBid, purchaseContractLocation, offerCashPrice, purchaseContractNumberOfBushels, moment(offerExpirationDate).format('YYYY-MM-DD'), purchaseContractComments, ipifyResponseJson.ip);
  }
  catch (error) {
    dispatch({
      type: 'SAVE_OFFER_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'SAVED_OFFER',
    success: response.body.success,
  });
});

export const fetchOffers = () => (async (dispatch, getState) => {
  dispatch({
    type: 'FETCH_OFFERS_STARTED',
  });
  var response = null;
  try {
    response = await getOffers(getState().auth.authorization.agvanceUser, getState().auth.authorization.emailAddress);
  }
  catch (error) {
    dispatch({
      type: 'FETCH_OFFERS_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_OFFERS',
    offers: response.body,
  });
});

export const userTappedCancelOffer = (offerId) => (async (dispatch, getState) => {
  dispatch({
    type: 'SHOW_CANCEL_OFFER_MODAL',
    offerId: offerId,
  });
});

export const hideCancelOfferModal = (offerId) => (async (dispatch, getState) => {
  dispatch({
    type: 'HIDE_CANCEL_OFFER_MODAL',
  });
});

export const userCancelledOffer = () => (async (dispatch, getState) => {
  dispatch({
    type: 'CANCEL_OFFER_STARTED',
  });
  const agvanceUser = getState().auth.authorization.agvanceUser;
  const emailAddress = getState().auth.authorization.emailAddress;
  const offerIdToCancel = getState().cashBids.offerIdToCancel;
  var response = null;
  try {
    response = await cancelOffer(agvanceUser, emailAddress, offerIdToCancel);
  }
  catch (error) {
    dispatch({
      type: 'CANCEL_OFFER_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'CANCELLED_OFFER',
    success: response.body.success,
  });
  dispatch(fetchOffers());
});